import styled, { css } from "styled-components";
import RadioGroup from "@mui/material/RadioGroup";
import { HXButton } from "./HXButton";
import { colors } from "healthex-common/colors";
import { FlexColumn, FlexRow } from "./common.styles";
import { LighterTinyText } from "./HXDesktopPage.styles";
import { fontWeights } from "healthex-common/weights";
import { fontSizes } from "healthex-common/sizes";
export const HXCustomRadioButtonIndentedRadioGroup = styled(RadioGroup) `
    gap: 16px;
    align-self: stretch;
    align-items: stretch;

    & .MuiFormControlLabel-root {
        margin-left: 0px; // remove default styling of -11px
    }
`;
export const HXCustomRadioButtonContainerButton = styled(HXButton).attrs({ secondary: true }) `
    display: flex;
    min-height: ${(props) => { var _a; return (_a = props.minHeight) !== null && _a !== void 0 ? _a : 68; }}px;
    padding: 8px;
    align-self: stretch;
    justify-content: flex-start;
    align-items: center;
    width: 100%;

    ${(props) => props.isSelected
    ? css `
                  background-color: ${colors.navy_4};
                  border-color: ${colors.navy_main};
              `
    : css `
                  background-color: ${colors.white_main};
                  border-color: ${colors.navy_12};
              `}

    ${(props) => props.hasSubtext &&
    css `
            min-height: 90px;
            padding: 16px 8px;
        `}
`;
export const HXCustomRadioButtonContainer = styled(FlexRow) `
    align-self: stretch;
    justify-content: center;
    align-items: center;
    flex: 1 0 0;
`;
export const HXCustomRadioButtonContent = styled(FlexColumn) `
    flex: 1 0 0;
    align-self: center;
    padding-right: ${(props) => (props.removePadding ? "0" : "42")}px;
`;
export const HXCustomRadioButtonTextWrapper = styled(FlexRow) `
    gap: 6px;
    align-self: stretch;
    justify-content: ${(props) => (props.alignLeft ? "start" : "center")};
    align-items: ${(props) => (props.alignLeft ? "start" : "center")};
`;
export const HXCustomRadioButtonSubtext = styled(LighterTinyText) `
    text-align: start;
`;
export const HXCustomMobileRadioButtonIndentedRadioGroup = styled(RadioGroup) `
    gap: 8px;
    align-self: stretch;
    align-items: stretch;

    & .MuiFormControlLabel-root {
        margin-left: 0px; // remove default styling of -11px
        margin-right: 12px;
    }

    & .MuiRadio-root {
        padding: 0;
    }
`;
export const HXCustomMobileRadioButtonContainerButton = styled(HXButton).attrs({ secondary: true }) `
    display: flex;
    min-height: 58px;
    padding: 12px 12px 12px 16px;
    align-self: stretch;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    border-radius: 12px;
    color: ${colors.black_light};
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    border-color: ${colors.blue_30};
    background-color: ${colors.white_background};

    ${(props) => props.isSelected &&
    css `
            background-color: ${colors.blue_10} !important;
        `};

    ${(props) => props.error &&
    css `
            border-color: ${colors.tulip_main};
        `}
`;
export const HXCustomRadioButtonContainerButtonMobile = styled(HXButton).attrs({ secondary: true }) `
    display: flex;
    min-height: 56px;
    padding: 12px;
    align-self: stretch;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    border-radius: 12px;
    color: ${colors.black_light};
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    border-color: ${colors.blue_30};
    background-color: ${colors.white_background};

    ${(props) => props.isSelected &&
    css `
            background-color: ${colors.blue_10} !important;
        `}

    ${(props) => props.hasSubtext &&
    css `
            min-height: 72px;
            align-items: center;
        `}

    ${(props) => props.minHeight !== undefined &&
    css `
            min-height: ${props.minHeight}px;
        `}
`;
export const HXCustomMobileRadioButtonContainer = styled(FlexRow) `
    align-self: stretch;
    justify-content: center;
    align-items: center;
    flex: 1 0 0;
`;
export const HXCustomMobileRadioButtonContent = styled(FlexColumn) `
    flex: 1 0 0;
    align-self: center;
`;
export const HXCustomMobileRadioButtonTextWrapper = styled(FlexRow) `
    gap: 6px;
    align-self: stretch;
    justify-content: start;
    align-items: start;
`;
